/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import { ReactQueryDevtools } from "react-query/devtools";
import ReactDOM from "react-dom";
import { AppProviders } from "./AppProviders";
import { App } from "./App";

if (process.env.NODE_ENV === "development") {
  const { worker } = require("./mocks/server");
  worker.start();
}

ReactDOM.render(
  <AppProviders>
    <ReactQueryDevtools />
    <App />
  </AppProviders>,
  document.getElementById("root")
);
